import { render } from "./QuestionBankList.vue?vue&type=template&id=cb3d3fba&scoped=true"
import script from "./QuestionBankList.vue?vue&type=script&lang=js"
export * from "./QuestionBankList.vue?vue&type=script&lang=js"

import "./QuestionBankList.vue?vue&type=style&index=0&id=cb3d3fba&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb3d3fba"]])

export default __exports__